import { transport } from '@opengov/app-core/transport';
import { useMutation } from '@tanstack/react-query';
import { customReportsQueryKeys } from '../../hooks/customReportsQueryKeys';

type DeleteSpreadsheetResponse = {
  success: boolean;
};

type Params = {
  publicationId: string;
  spreadsheetId: string;
};

async function deleteSpreadsheet({ publicationId, spreadsheetId }: Params): Promise<DeleteSpreadsheetResponse> {
  return transport.url(`/api/stories/v1/publications/${publicationId}/spreadsheets/${spreadsheetId}`).delete().json();
}

export function useDeleteSpreadsheet({ publicationId }: { publicationId: string }) {
  return useMutation({
    mutationKey: customReportsQueryKeys.deleteSpreadsheet(),
    mutationFn: (params: Omit<Params, 'publicationId'>) => deleteSpreadsheet({ ...params, publicationId })
  });
}
